import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-app-download',
  templateUrl: './app-download.component.html',
  styleUrls: ['./app-download.component.scss']
})
export class AppDownloadComponent {

	@Input() data: any = {};
	@Input() eapUrl: string = '';
	@Input() groupCode: string = '';
	@Input() groupCodeLabel: string = '';
}
